import moment from 'moment'
import { getI18n } from '@/plugins/i18n'

import * as dataGridColumn from '@/composables/data-grid-column'
import * as dataGrid from '@/composables/data-grid'

import { useRegistryStore } from '@/stores/registry.store'
import { usePortalStore } from '@/stores/portal.store'

export const useColumns = () => {
  const i18n = getI18n()
  const registryStore = useRegistryStore()
  const portalStore = usePortalStore()

  return [
    dataGridColumn.useDateTimeColumn({
      dataField: 'movement_datetime',
      caption: i18n.t('common.date'),
      sortOrder: 'desc',
      setCellValue(newData, value) {
        newData['movement_datetime'] = value ? moment(value).utc().toISOString() : null
      },
      editorOptions: {
        max: moment().utc().toISOString(),
      },
      validationRules: [{
        type: 'custom',
        message: i18n.t('error.validation.event_past_date'),
        validationCallback: (e) => !e.value || moment(e.value).utc().toISOString() <= moment().utc().toISOString(),
      }],
    }),
    {
      dataField: 'movement_type',
      caption: i18n.t('common.type'),
      lookup: dataGrid.useLookup({ store: registryStore.getLocalizedVehicleMovementTypes() })
    },
    dataGridColumn.useCustomerColumn({
      caption: i18n.t('common.owner'),
      dataField: 'customer_id',
      editCellTemplate: 'customerEditor',
    }),
    {
      dataField: 'vehicle_info.protocol',
      caption: i18n.t('common.protocol'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.color',
      caption: i18n.t('common.color'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.engine_code',
      caption: i18n.t('common.engineCode'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.engine_size',
      caption: i18n.t('common.cubicCapacity'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.fuel_type',
      caption: i18n.t('common.vehicleFuelType'),
      editorOptions: { readOnly: true },
      lookup: dataGrid.useLookup({ store: registryStore.getLocalizedVehicleFuelTypes() }),
      visible: false
    },
    {
      dataField: 'vehicle_info.name',
      caption: i18n.t('common.name'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.plate_number',
      caption: i18n.t('common.plate'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.status',
      caption: i18n.t('common.status'),
      editorOptions: { readOnly: true },
      lookup: dataGrid.useLookup({ store: registryStore.getLocalizedVehicleStatusTypes() }),
      visible: false
    },
    {
      dataField: 'vehicle_info.vin',
      caption: i18n.t('common.vin'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.notes',
      caption: i18n.t('common.note'),
      editorOptions: { readOnly: true },
      visible: false
    },
    {
      dataField: 'vehicle_info.type',
      caption: i18n.t('common.vehicleType'),
      editorOptions: { readOnly: true },
      lookup: dataGrid.useLookup({ store: portalStore.getLocalizedVehicleTypes() }),
      visible: false
    },
    dataGridColumn.useSupplierBrandColumn({
      dataField: 'vehicle_info.supplier_brand_ref',
      visible: false,
      editorOptions: { readOnly: true }
    }),
  ]
}
